import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DropdownRequest,
  FormattedDrug,
  OtherFormularyInformation,
  SearchMore,
} from '@cigna/pdl-viewer/drug-search/data-access';
import { ActivatedRoute } from '@angular/router';
import { PdlGateway } from '@cigna/pdl-viewer/shared/gateway-util';
import { alphaBiList } from '@cigna/pdl-viewer/shared/util';
import flatten from 'lodash/flatten';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Component({
  selector: 'cigna-drug-search-results-table',
  templateUrl: './drug-search-results-table.component.html',
  styleUrls: ['./drug-search-results-table.component.scss'],
})
export class DrugSearchResultsTableComponent implements OnInit {
  @Output() getDrugList = new EventEmitter<string>();
  @Output() getTherapeuticDrugList = new EventEmitter<SearchMore>();
  @Output() loadMoreData = new EventEmitter<number>();
  @Input() alphabet: string;
  @Input() indicator: string;
  @Input() selectedItemDropDown: string;
  @Input() selectedItem: DropdownRequest;
  @Input() otherInfo: OtherFormularyInformation;
  @Input() consumerId: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showSearchInfo: boolean;
  @Input() loadedDataLength: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() isClassCodeClicked: boolean;
  _drugList: FormattedDrug[];
  notesCollection: string[];
  rsdLimit: string;
  msdLimit: string;
  planCode: string;
  atoz: string[] = [];
  alphaBiList = alphaBiList;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  showTableData: boolean;
  downloadPdf: string;
  isNYMessage: boolean;

  constructor(
    private activRoute: ActivatedRoute,
    private _gw: PdlGateway,
    private windowService: WindowService,
  ) {}

  ngOnInit(): void {
    this.atoz = this.alphaBiList.atoz;
    if (this.consumerId !== 'chcp') {
      this.downloadPdf = `${this._gw.downloadPdfPublicURL()}`;
    }
    this.isNYMessage =
      (this.activRoute.snapshot.queryParams.pdlYearType === 'NY' &&
        this.notesCollection.indexOf('DS') > -1) ||
      false;
  }

  @Input()
  set selectedDrugList(drugList: FormattedDrug[]) {
    let notes: string[] = [];
    this._drugList = [...[], ...drugList];
    drugList.forEach((item) => {
      if (item.notes !== undefined) {
        notes = [...notes, ...item.notes] as string[];
      }
      if (
        item.retailSpecialtyDayLimit !== undefined &&
        item.mailSpecialtyDayLimit !== undefined
      ) {
        this.rsdLimit = item.retailSpecialtyDayLimit;
        this.msdLimit = item.mailSpecialtyDayLimit;
      }
    });
    const emptyNotes: string[] = notes.filter((array) => array.length);
    const mergedNotes: string[] = flatten(emptyNotes);
    this.notesCollection = mergedNotes.filter(
      (element, i) => i === mergedNotes.indexOf(element),
    );
    this.showTableData = drugList.length > 0;
  }

  get selectedDrugList(): FormattedDrug[] {
    return this._drugList;
  }
  drugsListClick(drugName: string) {
    this.alphabet = drugName;
    this.getDrugList.emit(drugName);
  }
  loadMore() {
    this.isClassCodeClicked = false;
    this.loadMoreData.emit();
  }

  pageToTop() {
    this.windowService.scrollTo(0, 0);
  }

  loadTherapeuticCode(code: string, isLoadMore: boolean) {
    this.showSearchInfo = false;
    this.isClassCodeClicked = true;
    this.getTherapeuticDrugList.emit({ query: code, isLoadMore });
    this.pageToTop();
  }
}
